export default __webpack_public_path__ + "static/media/13-1.9df0b1d4.mp3";